import { leaseEndDateFromStartTermRule, leaseStartDateFromEndTermRule, leaseTermFromDatesRule } from './lease-term.calc.js';
import { leaseRentConversionRules } from './rent-conversion.calc.js';
import { leaseRentRateRules } from './rent-rates.calc.js';
/** Every lease-domain rule, in one registry. */
export const leaseRules = [leaseEndDateFromStartTermRule, leaseStartDateFromEndTermRule, leaseTermFromDatesRule, ...leaseRentConversionRules, ...leaseRentRateRules];
export const leaseRegistry = {
  domain: 'lease',
  rules: leaseRules
};
